/* istanbul ignore file */
import { Show } from 'framework/show';
import { ShowPageLayout, ShowSection } from 'framework/ui/layout';
import ContractsHeader from 'domain/people/contracts/shared/ContractsHeader';
import useContractsService from 'domain/people/contracts/shared/contractsService';
import SingleContractsBreadcrumbs from 'domain/people/contracts/Show/Breadcrumbs';
import ContractsMenu from 'domain/people/contracts/shared/ContractsMenu';
import { useContractsId } from 'domain/people/contracts/contractsRouting';
import ContractsViewFields from 'domain/people/contracts/shared/ContractsViewFields';

const ViewContracts = () => {
  const { getById } = useContractsService();
  const id = useContractsId();

  return (
    <Show getDataMethod={() => getById(id)}>
      <ShowPageLayout
        menu={<ContractsMenu />}
        entityHeader={<ContractsHeader />}
        breadcrumbs={<SingleContractsBreadcrumbs />}
      >
        <ShowSection title="Contracts details">
          <ContractsViewFields />
        </ShowSection>
      </ShowPageLayout>
    </Show>
  );
};

export default ViewContracts;
